import React, { useEffect, useRef, useState } from "react";
import ProductImage from "../../assets/watch_product.svg";
import WatchGold from "../../../assets/watch_gold.svg";
import InnovationsGrey from "../../assets/philisophy/innovations_grey.svg";
import PhilisophyPurple from "../../../assets/philisophy/philosophy_purple.svg";
import PhilisophyContent from "../../assets/philisophy/innovations_content.svg";
import PhilisophyMobile from "../../../assets/mobile/philosophy_main_mobile.svg";
import ReactMarkdown from 'react-markdown';

import "./Patents.css";
import BackgroundCover from "../../../components/backgroundCover/BackgroundCover";
import { debounce } from "../../../utils/utilFunctions";
import { isMobile } from "../../../utils/appUtils";
import { Link } from 'react-router-dom';
import PatentsGray from "../../../assets/philisophy/philosophy_grey.svg";
import { COMPONENT_COLORS } from '../../../utils/componentColors';


const colors = [
  "#ff0000",
  "#00ff00",
  "#0000ff",
  "#ffff00",
  "#ff00ff",
  "#00ffff",
  "#800080",
  "#ffa500",
  "#008000",
];
const materials = ["#F5F5F5", "#D3D3D3", "#A9A9A9", "#808080", "#696969"];

const Patents: React.FC = () => {
  const [activeButton, setActiveButton] = useState("farbe");
  const [markdownContent, setMarkdownContent] = useState('');
  const colorFont = COMPONENT_COLORS.TEXT.LIGHT;
  const defaultColorFont = COMPONENT_COLORS.TEXT.DARK;
  const backgroundImageRef = useRef(null);

  useEffect(() => {
    const fetchMarkdownContent = async () => {
      try {
        const response = await fetch('/innovations.md');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("text/html") !== -1) {
          throw new Error("Received HTML instead of Markdown");
        }
        const text = await response.text();
        console.log("Fetched markdown content:", text); // Debug log
        setMarkdownContent(text);
      } catch (error) {
        console.error('Error fetching markdown:', error);
        setMarkdownContent('Failed to load content. Please try again later.');
      }
    };

    fetchMarkdownContent();
  }, []);

  const getSection = (sectionName: string): string => {
    const sectionRegex = new RegExp(`## ${sectionName}([\\s\\S]*?)(?=## |$)`, 'i');
    const match = markdownContent.match(sectionRegex);
    return match ? match[1].trim() : '';
  };

  const getSectionParagraphs = (sectionName: string): string[] => {
    const sectionRegex = new RegExp(`## ${sectionName}([\\s\\S]*?)(?=## |$)`, 'i');
    const match = markdownContent.match(sectionRegex);

    if (match) {
      const sectionContent = match[1].trim();
      // Split the content into paragraphs based on double newlines or single newlines followed by a space.
      return sectionContent.split(/\n\s*\n|\r?\n(?!\s*\n)/).filter(p => p);
    }

    return [];
  };

  const subPanel1Paragraphs = getSectionParagraphs('Sub Panel 1 - Content');
  const subPanel2Paragraphs = getSectionParagraphs('Sub Panel 2 - Content');
  const subPanel3Paragraphs = getSectionParagraphs('Sub Panel 3 - Content');
  const subPanel4Paragraphs = getSectionParagraphs('Sub Panel 4 - Content');
  const subPanel5Paragraphs = getSectionParagraphs('Sub Panel 4 - Content');

  return (
    <div className="patents-container">
      <BackgroundCover backgroundHeight={400}
        imagePosition='inherit' backgroundImage={PatentsGray} />

      <div className="patents-content">
        <>
          <h1 className="patents-main-title">PATENTS</h1>

          <div className="patents-main-content">
            <div className="patents-main-left">
              <p className="patents-title">PLACEHOLDER TEXT</p>
              <span className="patents-title-content">Patents by Inventor Michael Bonke. Michael Bonke has filed for
                patents to protect the following inventions. This listing includes
                patent applications that are pending as well as patents that have
                already been granted by the United States Patent and Trademark
                Office (USPTO).
              </span>
            </div>
          </div>
        </>

        <div className="centered-div">
          <p className="patents-title">PLACEHOLDER</p>
          <ul>
            <li>
              <u>WATCH GLASS COMPRISING A DECORATIVE ELEMENT</u>
            </li>
            <li>Publication number: 20230176529</li>
            <li>
              Abstract: A watch glass includes a first glass, a second glass and a
              decorative element. The second glass is connected to the first glass
              via a connecting intermediate layer. The decorative element is
              inserted in a setting, which is arranged in a watch glass recess.
              The watch glass recess is formed by a first recess in the first
              glass and a second recess in the second glass. Here, a space of the
              watch glass recess is defined by the first glass, the second glass
              and the setting. The space is filled with connecting material of the
              connecting intermediate layer, so that the setting is connected via
              the connecting material to the first glass and the second glass.
            </li>
            <li>Type: Application</li>
            <li>Filed: April 29, 2021</li>
            <li>Publication date: June 8, 2023</li>
            <li>Inventor: Michael BONKE</li>
          </ul>
          <ul>
            <li>
              <u>WATCH GLASS WITH A DECORATIVE ELEMENT</u>
            </li>
            <li>Publication number: 20220276612</li>
            <li>
              Abstract: A watch glass includes a first glass, second glass and a
              decorative element, in particular a gemstone. Here, the first glass
              and the second glass are connected to one another via a connecting
              intermediate layer. The first glass comprises a continuous recess.
              The decorative element comprises a base region, which is arranged
              settingless in the recess of the first glass and in direct contact
              with the connecting intermediate layer. Further, the invention
              relates to a watch with such a watch glass.
            </li>
            <li>Type: Application</li>
            <li>Filed: April 29, 2021</li>
            <li>Publication date: September 1, 2022</li>
            <li>Inventor: Michael BONKE</li>
          </ul>
          <ul>
            <li>
              <u>Watch glass and method for producing a watch glass</u>
            </li>
            <li>Patent number: 11378919</li>
            <li>
              Abstract: Provided is a watch glass including a support glass having
              at least one recess, a cover glass, at least one gemstone which is
              at least in part disposed in the recess, and a connecting
              intermediate layer by way of which the cover glass and the support
              glass are connected to one another. A region of an upper part of the
              gemstone is in direct contact with the intermediate layer.
            </li>
            <li>Type: Grant</li>
            <li>Filed: November 7, 2017</li>
            <li>Date of Patent: July 5, 2022</li>
            <li>Assignee: REALIZATION DESAL AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>
          <ul>
            <li>
              <u>WATCH GLASS WITH A DECORATIVE ELEMENT</u>
            </li>
            <li>Publication number: 11375779</li>
            <li>
              Abstract: The invention relates to a gemstone including a crown
              having a multiplicity of crown facets and a table, a girdle, and a
              pavilion having a multiplicity of pavilion facets, wherein a crown
              angle is between 34.5° and 35.5°, and is preferably 35°, and a
              pavilion angle is between 40° and 41°, preferably between 40.2° and
              40.8°, and is particularly preferably 40.5°.
            </li>
            <li>Type: Grant</li>
            <li>Filed: January 29, 2019</li>
            <li>Date of Patent: July 5, 2022</li>
            <li>Assignee: REALIZATION DESAL AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>
          <ul>
            <li>
              <u>
                GEMSTONE ARRANGEMENT AND METHOD FOR PRODUCING A GEMSTONE
                ARRANGEMENT
              </u>
            </li>
            <li>Publication number: 20210112930</li>
            <li>
              Abstract: The invention relates to a gemstone arrangement, that
              comprises a first gemstone element, a second gemstone element, which
              is connected to the first gemstone element, and at least one
              decorative element, which is arranged between the first gemstone
              element and the second gemstone element. Furthermore, the invention
              relates to a method for producing the gemstone arrangement. A
              further aspect of the invention relates to a jewel with a gemstone
              arrangement.
            </li>
            <li>Type: Application</li>
            <li>Filed: January 29, 2019</li>
            <li>Publication date: April 22, 2021</li>
            <li>Inventor: Michael BONKE</li>
          </ul>
          <ul>
            <li>
              <u>Watch glass with at least one gemstone</u>
            </li>
            <li>Patent number: 10838367</li>
            <li>
              Abstract: The invention relates to a watch, comprising a gemstone, a
              setting, which has a pin-shaped projection and in which the gemstone
              is accommodated, and a watch glass including a continuous recess
              which at least the pin-shaped projection of the setting is arranged,
              the pin-shaped projection being fastened to the watch glass.
            </li>
            <li>Type: Grant</li>
            <li>Filed: June 30, 2015</li>
            <li>Date of Patent: November 17, 2020</li>
            <li>Assignee: LEVITATION AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>
          <ul>
            <li>
              <u>WATCH GLASS WITH LUMINESCENT ELEMENT</u>
            </li>
            <li>Publication number: 20190369562</li>
            <li>
              Abstract: The invention relates to a watch glass comprising a cover
              glass, a support glass connected with the cover glass for forming a
              glass unit and a luminescent element introduced into the glass unit.
              Furthermore, the invention relates to a watch comprising such a
              watch glass.
            </li>
            <li>Type: Application</li>
            <li>Filed: November 7, 2017</li>
            <li>Publication date: December 5, 2019</li>
            <li>Inventor: MICHAEL BONKE</li>
          </ul>
          <ul>
            <li>
              <u>GEMSTONE</u>
            </li>
            <li>Publication number: 20190298011</li>
            <li>
              Abstract: The invention relates to a gemstone including a crown
              having a multiplicity of crown facets and a table, a girdle, and a
              pavilion having a multiplicity of pavilion facets, wherein a crown
              angle is between 34.5° and 35.5°, and is preferably 35°, and a
              pavilion angle is between 40° and 41°, preferably between 40.2° and
              40.8°, and is particularly preferably 40.5°.
            </li>
            <li>Type: Application</li>
            <li>Filed: July 11, 2017</li>
            <li>Publication date: October 3, 2019</li>
            <li>Inventor: MICHAEL BONKE</li>
          </ul>
          <ul>
            <li>
              <u>WATCH GLASS AND METHOD FOR PRODUCING A WATCH GLASS</u>
            </li>
            <li>Publication number: 20190271951</li>
            <li>
              Abstract: The invention relates to a watch glass which comprises a
              support glass having at least one recess; a cover glass; at least
              one gemstone which is at least in part disposed in the recess; and a
              connecting intermediate layer by way of which the cover glass and
              the support glass are connected to one another. A region of an upper
              part of the gemstone is in direct contact with the intermediate
              layer. The invention furthermore relates to a watch having a watch
              glass of this type as well as to a method for producing a watch
              glass of this type.
            </li>
            <li>Type: Application</li>
            <li>Filed: November 7, 2017</li>
            <li>Publication date: September 5, 2019</li>
            <li>Inventor: Michael BONKE</li>
          </ul>
          <ul>
            <li>
              <u>Watch glass and method for producing a watch glass</u>
            </li>
            <li>Patent number: 10076987</li>
            <li>
              Abstract: The invention relates to a watch glass, in particular a
              watch glass with at least one gemstone. The method includes the
              following steps: providing a support glass; and providing a cover
              glass. The cover glass and the support glass are connected to one
              another by way of a connecting intermediate layer. A gemstone is
              arranged in a recess of the support glass, and a connecting
              intermediate layer is applied to a region of the gemstone in direct
              contact with the intermediate layer. The invention further relates
              to a watch glass produced in this manner.
            </li>
            <li>Type: Grant</li>
            <li>Filed: December 22, 2015</li>
            <li>Date of Patent: September 4, 2018</li>
            <li>Assignee: Realization Desal AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>
                Method for producing a watch glass having at least one gemstone
              </u>
            </li>
            <li>Patent number: 10067476</li>
            <li>
              Abstract: The invention relates to a method for producing a watch
              glass, in which at least one diamond or jewel, or other gemstone is
              embedded. The method comprises the steps of providing a carrier
              glass, providing a cover glass, introducing at least one recess into
              the carrier glass, providing at least one diamond, jewel, or other
              gemstone, inserting the at least one diamond, jewel, or gemstone
              into the recess of the carrier glass, placing the cover glass on the
              carrier glass, and connecting the cover glass to the carrier glass
              such that an airtight connection point between the cover glass and
              the carrier glass is formed, which is subject to a suction cup
              effect. The invention further relates to a watch glass produced
              according to this method and a watch incorporating such a watch
              glass.
            </li>
            <li>Type: Grant</li>
            <li>Filed: June 30, 2015</li>
            <li>Date of Patent: September 4, 2018</li>
            <li>Assignee: Levitation AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>WATCH GLASS WITH AT LEAST ONE GEMSTONE</u>
            </li>
            <li>Publication number: 20180113422</li>
            <li>
              Abstract: The invention relates to a watch glass, comprising at
              least one gemstone, a setting, which has at least one pin-shaped
              projection and in which the gemstone is accommodated, and at least
              one continuous recess in which at least the pin-shaped projection of
              the setting is arranged, the pin-shaped projection being fastened to
              the watch glass. The invention further relates to a watch comprising
              a watch glass according to the invention.
            </li>
            <li>Type: Application</li>
            <li>Filed: June 30, 2015</li>
            <li>Publication date: April 26, 2018</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>
                METHOD FOR PRODUCING A WATCH GLASS HAVING AT LEAST ONE GEMSTONE
              </u>
            </li>
            <li>Publication number: 20180059623</li>
            <li>
              Abstract: The invention relates to a method for producing a watch
              glass having at least one gemstone, comprising the steps of
              providing a support glass, providing a cover glass, introducing at
              least one recess into the support glass, providing at least one
              gemstone, inserting the at least one gemstone into the recess in the
              support glass, placing the cover glass onto the support glass and
              securing the entire arrangement consisting of the support glass and
              the cover glass by means of a holding element surrounding a
              circumference of the entire arrangement. Furthermore, the invention
              relates to a watch glass which is produced by this method.
            </li>
            <li>Type: Application</li>
            <li>Filed: June 30, 2015</li>
            <li>Publication date: March 1, 2018</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>
                METHOD FOR PRODUCING A WATCH GLASS HAVING AT LEAST ONE GEMSTONE
              </u>
            </li>
            <li>Publication number: 20180059622</li>
            <li>
              Abstract: The invention relates to a method for producing a watch
              glass, in which at least one diamond or jewel, or other gemstone is
              embedded. The method comprises the steps of providing a carrier
              glass, providing a cover glass, introducing at least one recess into
              the carrier glass, providing at least one diamond, jewel, or other
              gemstone, inserting the at least one diamond, jewel, or gemstone
              into the recess of the carrier glass, placing the cover glass on the
              carrier glass, and connecting the cover glass to the carrier glass
              such that an airtight connection point between the cover glass and
              the carrier glass is formed, which is subject to a suction cup
              effect. The invention further relates to a watch glass produced
              according to this method and a watch incorporating such a watch
              glass.
            </li>
            <li>Type: Application</li>
            <li>Filed: June 30, 2015</li>
            <li>Publication date: March 1, 2018</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>Cut stone</u>
            </li>
            <li>Patent number: D829124</li>
            <li>Type: Grant</li>
            <li>Filed: May 9, 2017</li>
            <li>Date of Patent: September 25, 2018</li>
            <li>Assignee: REALIZATION DESAL AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>Watch face</u>
            </li>
            <li>Patent number: D852664</li>
            <li>Type: Grant</li>
            <li>Filed: May 1, 2017</li>
            <li>Date of Patent: July 2, 2019</li>
            <li>Assignee: Realization Desal AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>Cut stone</u>
            </li>
            <li>Patent number: D883134</li>
            <li>Type: Grant</li>
            <li>Filed: September 19, 2018</li>
            <li>Date of Patent: May 5, 2020</li>
            <li>Assignee: REALIZATION DESAL AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>

          <ul>
            <li>
              <u>Cut stone</u>
            </li>
            <li>Patent number: D883847</li>
            <li>Type: Grant</li>
            <li>Filed: September 19, 2018</li>
            <li>Date of Patent: May 12, 2020</li>
            <li>Assignee: REALIZATION DESAL AG</li>
            <li>Inventor: Michael Bonke</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Patents;